import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import slideType from "./types/slideType";
import {
  CarouselWrapper,
  CarouselSlide,
  CarouselImage,
} from "./styles/carousel-styles";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Carousel = (props) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    fade: true,
    cssEase: "linear",
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToScroll: 1,
    arrows: false,
  };
  const { slides } = props;

  return (
    <CarouselWrapper>
      <Slider {...settings}>
        {slides.map(({ id, link }) => (
          <CarouselSlide key={id}>
            <CarouselImage src={link} alt="Image" />
          </CarouselSlide>
        ))}
      </Slider>
    </CarouselWrapper>
  );
};

Carousel.propTypes = {
  slides: PropTypes.arrayOf(slideType).isRequired,
};

export default Carousel;
